import React from 'react'
import styles from './ublcsModal.scss';
import { Modal, withPortal } from 'jd-library';
import Button from "../../common/Button/Button";


const UBLCSModal = (props) => {
    
  return (
    <Modal
            settings={{
                modalId: "CorrectnessProduct",
                variant: "action",
                class: styles["correctness-model"],
            }}
            backdropStatic={true}
            onHidden={() => props.onHidden()}
            >
            <Modal.CloseIcon iconClass={'icon-HDRcross'} />
            <div className={`${styles["title"]} `}></div>
                <div className={styles["content"]}  body-scroll-lock-ignore='true'>
                    {<p>You do not have permission to make changes to this digital catalogue. </p> }
                </div>
            <div className={styles["footer"]}>
                <Button
                    size="lg"
                    block
                    variant={"primary"}
                    className={styles["btn"]}
                    clickHandler={() => props.onHidden()}>
                    Okay, Got It
                </Button>
            </div>
        </Modal>
  )
}

export default withPortal(UBLCSModal)